export const TOOL_TASK = 'unassign-product-account-entitlements';
export const TOOL_TITLE = 'Unassign Account Resources';
export const TOOL_PROGRESS_LABEL = 'Progress of unassigning resources from the account...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once unassigning resources from the account finishes';
